<template>
  <div>
    <div class="payments-container" v-if="paymentTypes">
      <ion-item v-for="(payment, index) of payments" :key="index">
        <ion-select
          :selected-text="paymentTypes.length > 0 && payment.payment_type_id !== null ? paymentTypes.filter((p) => {return p.id == payment.payment_type_id})[0].name : ''"
          v-model="payment.payment_type_id"
          interface="popover"
          value="brown"
          cancel-text="Dismiss"
        >
          <ion-select-option
            v-for="paymentType of paymentTypes"
            :value="paymentType.id"
            :key="paymentType.id"
            >{{ paymentType.name }}</ion-select-option
          >
        </ion-select>
        <ion-input type="number" v-model="payment.amount"></ion-input>
        <div>€</div>
        <ion-button @click="removeItem(payments, payment)" color="light"
          ><ion-icon slot="icon-only" :icon="trash"></ion-icon
        ></ion-button>
      </ion-item>
      <ion-button @click="addPayment" expand="block"
        >Afegir pagament</ion-button
      >
    </div>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import { defineComponent } from "vue";
import axios from "axios";
import {
  IonItem,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonButton,
  IonIcon,
} from "@ionic/vue";
import { arrowForward, trash } from "ionicons/icons";
import moment from "moment";

export default defineComponent({
  setup() {
    return {
      arrowForward,
      trash,
    };
  },
  components: {
    IonItem,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonButton,
    IonIcon,
  },
  props: {
    modelValue: {
      required: false,
      default: []
    },
    bookingId: {
      required: false,
      type: Number,
    },
  },
  watch: {
    payments: {
      deep: true,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
  },
  data: () => ({
    paymentTypes: [],
    payments: [],
  }),
  beforeMount() {
    if (this.modelValue !== undefined && this.modelValue !== null) {
      this.payments = [].concat(this.modelValue);
    }
    this.getPaymentTypes();
  },
  methods: {
    getPaymentTypes() {
      axios.get("/payment-types").then((resp) => {
        this.paymentTypes = resp.data;
        this.$forceUpdate();
      });
    },
    addPayment() {
      this.payments.push({
        booking_id: this.bookingId ?? null,
        payment_type_id: 1,
        amount: "",
      });
    },
    removeItem(arr, value) {
      const index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
      return arr;
    },
  },
  computed: {},
});
</script>

<style lang="scss" scoped>
.payments-container {
  padding: 20px;
  background: #eceff0;
  ion-select {
    margin-right: 20px;
  }
}
ion-item {
  ion-button {
    margin-left: 20px;
  }
}
</style>
